export const testimonials = [
  {
    id: 1,
    title: "Recommended",
    text: "It was a great opportunity to connect with Springevening for the Digital Directory of Inner Wheel District 317. The design and content were perfectly tailored to our requirements. The staff were cooperative and updated our information swiftly. A wonderful experience with a dedicated team. Strongly recommend for perfection and hassle-free service.",
    author: "Jyothi Kiran Das",
    role: "Inner Wheel District Chairman (2024–25)",
    avatar: "/assets/testimonials/jyothikiran.jpg",
    stack: ["Web Design", "Content Management", "Branding"],
  },
  {
    id: 2,
    title: "Outstanding Partnership",
    text: "We have been using the client's lightweight custom ERP for the past two years, and it has been running efficiently, seamlessly supporting our daily operations. Their team also developed a customer-centric website for our company, which truly reflects our brand and values. They have been exceptionally good at customizing the software to match our unique business needs, ensuring it aligns perfectly with our workflows. Working with their passionate and professional team has been a truly rewarding experience. We wholeheartedly recommend their services to anyone seeking excellence and a smooth, stress-free journey.",
    author: "Siddanna Kerakalamatti",
    role: "Founder & CEO, Bit Byte Foods",
    avatar: "/assets/testimonials/siddubitbyte.jpg",
    stack: ["ERP System", "Custom Software", "Business Automation", "Website"],
  },
  {
    id: 3,
    title: "Excellent App Transition Experience",
    text: "We began working with Springevening after encountering challenges with our previous developer, and the experience has been exceptional. The team—especially CEO Shyam Sedamkar—has provided invaluable support throughout the transition, ensuring a seamless handover while actively enhancing our app. Beyond facilitating the transition, Springevening has brought valuable insights that have significantly improved the final product. The app is already looking better than ever, and we’re excited to continue working with them as we prepare for launch and bring it to market.",
    author: "Anjan Sandhu",
    role: "Co-founder, Careocity",
    avatar: "/assets/testimonials/anjancareocity.jpg",
    stack: ["Mobile App", "Web App", "Product Scaling", "UI/UX"],
  },
  {
    id: 4,
    title: "Strong Technical Discovery & Collaboration",
    text: "At the onset of the pandemic in early 2020, we urgently needed a reliable partner to help us navigate this challenge — and that's when we found Spring Evening.What stood out most was not just their technical acumen, but the professionalism and respect they brought to every interaction. The Spring Evening team proved to be knowledgeable, innovative,problem-solving and exceptional communicators. We're grateful for their partnership and look forward to continued collaboration.",
    author: "Theju Shetty",
    role: "Founder, Medicomp Solutions",
    avatar: "/assets/testimonials/thejuyeats.jpg",
    stack: [
      "macOS App",
      "Legacy System Upgrade",
      "Healthcare Tech",
      "RCM Product",
    ],
  },
  {
    id: 5,
    title: "Clean & Effective Web Presence",
    text: "We are extremely satisfied with the website developed by SpringEvening for ACT Amrita International School, Bagalkote. The design is clean, visually appealing, and easy to navigate, significantly enhancing user experience. The team was highly responsive to our needs, effectively incorporated our feedback, and delivered the project on time. We truly appreciate their dedication and the quality of their work.",
    author: "Raveendra V. Hulyal",
    role: "Principal, ACT Amrita International School",
    avatar: "/assets/testimonials/raviactsir.jpg",
    stack: ["Website", "Brand Visibility", "UI/UX", "SEO"],
  },
  {
    id: 6,
    title: "Professional & Modern Brand Presence",
    text: "We're extremely pleased with the website the client created for Amogh RMC. It strikes the perfect balance between simplicity and modern design, clearly presenting all the essential information about our brand. Thanks to their efforts, our company is now more searchable and visible online, and our customers have an easy and direct way to connect with us. The entire process was smooth, and we truly value their professionalism and attention to detail.",
    author: "Bheemsen Sedamkar",
    role: "MD & Founder, Amogh RMC",
    avatar: "/assets/testimonials/bheemsen.jpg",
    stack: [
      "Corporate Website",
      "Digital Presence",
      "Search Visibility",
      "Lead Generation",
    ],
  },
];
